import {RequestState} from "@pg-mono/request-state";

interface IRtkQueryStatus {
    isError: boolean;
    isFetching: boolean;
    isLoading: boolean;
    isSuccess: boolean;
}

export function getRequestStateFromRtkQuery(rtkQuery: IRtkQueryStatus): RequestState {
    if (rtkQuery.isFetching || rtkQuery.isLoading) {
        return RequestState.Waiting;
    }

    if (rtkQuery.isError) {
        return RequestState.Error;
    }

    if (rtkQuery.isSuccess) {
        return RequestState.Success;
    }

    return RequestState.None;
}
import {RequestState} from "@pg-mono/request-state";

interface IRtkQueryStatus {
    isError: boolean;
    isFetching: boolean;
    isLoading: boolean;
    isSuccess: boolean;
}

export function getRequestStateFromRtkQuery(rtkQuery: IRtkQueryStatus): RequestState {
    if (rtkQuery.isFetching || rtkQuery.isLoading) {
        return RequestState.Waiting;
    }

    if (rtkQuery.isError) {
        return RequestState.Error;
    }

    if (rtkQuery.isSuccess) {
        return RequestState.Success;
    }

    return RequestState.None;
}
